export function ExternalLinkIcon(props) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      display="inline-block"
      {...props}
    >
      <path
        d="M11.8203 3C11.268 3 10.8203 3.44772 10.8203 4C10.8203 4.55228 11.268 5 11.8203 5H14.4061L8.11321 11.2929C7.72268 11.6834 7.72268 12.3166 8.11321 12.7071C8.50373 13.0976 9.1369 13.0976 9.52742 12.7071L15.8203 6.41421V9C15.8203 9.55228 16.268 10 16.8203 10C17.3726 10 17.8203 9.55228 17.8203 9V4C17.8203 3.44772 17.3726 3 16.8203 3H11.8203Z"
        fill="currentColor"
      />
      <path
        d="M5.82031 5C4.71574 5 3.82031 5.89543 3.82031 7V15C3.82031 16.1046 4.71574 17 5.82031 17H13.8203C14.9249 17 15.8203 16.1046 15.8203 15V12C15.8203 11.4477 15.3726 11 14.8203 11C14.268 11 13.8203 11.4477 13.8203 12V15H5.82031V7L8.82031 7C9.3726 7 9.82031 6.55228 9.82031 6C9.82031 5.44772 9.3726 5 8.82031 5H5.82031Z"
        fill="currentColor"
      />
    </svg>
  );
}
